export default __webpack_public_path__ + "static/media/template_02.a624ac19.jpg";